<template>
  <div class="rowflex" align="center">
    <div style="width: 50%">
      <img :src="img" />
    </div>
    <div style="width: 50%">
      <h1 class="text-white" style="font-weight: 500">{{ header }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: ["header", "detail", "img", "color"],
};
</script>

<style scoped>
.rowflex {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>